<template>
<div class="animated fadeIn mt-5">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Distribuidor / CCSS</strong>
          </div>

          <b-form-row>
            <b-form-fieldset label="Mês dos Pontos" class="col-sm-4">
              <b-form-input type="text" name="points_release" v-model="item.points_release" placeholder="Mês dos Pontos"  v-validate="'required'" :state="validateState('points_release')"></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first('points_release') }}
              </b-form-invalid-feedback>
            </b-form-fieldset>
            <b-form-fieldset label="Limite de requisições" class="col-sm-4">
              <b-form-input type="date" name="requisitions_limit" v-model="item.requisitions_limit" placeholder="Limite de requisições"  v-validate="'required'" :state="validateState('requisitions_limit')"></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first('requisitions_limit') }}
              </b-form-invalid-feedback>
            </b-form-fieldset>
            <b-form-fieldset label="Requisições Activas" class="col-sm-4">
              <b-form-select :options="stateOptions" name="requisitions_enabled" v-model="item.requisitions_enabled" placeholder="Requisições Activas"  v-validate="'required'" :state="validateState('requisitions_enabled')" ></b-form-select>
              <b-form-invalid-feedback>
                {{ errors.first('requisitions_enabled') }}
              </b-form-invalid-feedback>
            </b-form-fieldset>
          </b-form-row>

          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'settings.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </div>
  </form>

</div>
</template>

<script>
import lists from '@/components/States.js'
export default {
  name: 'DealersEdit',
  props: ['id'],
  data() {
    return {
      item: {
        name: '',
        points_release: '',
        dealerufs: {
          data: []
        },
        zones: {
          data: []
        }
      },
      stateOptions: lists.states,
      dealerTypes: lists.dealerTypes
    }
  },
  methods: {
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      this.axios.put('settings', data)
        .then(response => {
          this.item = response.data.data
          this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
          if (close) {
            this.$router.push({
              name: 'settings.index'
            })
          }
        })
        .catch(response => {
          this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
        })
      }
  },
  created() {
    this.axios.get('settings')
      .then(response => {
        this.item = response.data.data
      })
      .catch(response => {
        this.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
        this.$router.push({
          name: 'settings.index'
        })
      })
  }
}
</script>
